// This file will build the plugin

import Balloon from './components/Balloon'
import BalloonSet from './components/BalloonSet'

import './styles/plugin.scss'

export default Balloon

export { Balloon, BalloonSet }



// WEBPACK FOOTER //
// ./src/index.js